module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data != undefined) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('models.project_lead.crawled_infos.more_infos')))]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [(_vm.data.logo) ? _c('div', {
    staticClass: "company-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.logo,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "social-networks"
  }, [(_vm.has(_vm.data, 'facebook.handle')) ? _c('div', [_c('a', {
    attrs: {
      "href": 'http://facebook.com/' + _vm.data.facebook.handle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/icons/icon-fb.svg"),
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'twitter.handle')) ? _c('div', [_c('a', {
    attrs: {
      "href": 'http://twitter.com/' + _vm.data.twitter.handle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/icons/icon-twitter.svg"),
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'linkedin.handle')) ? _c('div', [_c('a', {
    attrs: {
      "href": 'http://linkedin.com/' + _vm.data.linkedin.handle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/icons/icon-linkedin.svg"),
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'crunchbase.handle')) ? _c('div', [_c('a', {
    attrs: {
      "href": 'http://crunchbase.com/' + _vm.data.crunchbase.handle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/icons/icon-clearbit.svg"),
      "alt": ""
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.has(_vm.data, 'name')) ? _c('crawled-info', {
    attrs: {
      "label": "name",
      "value": _vm.data.name
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'domain')) ? _c('div', {
    staticClass: "crawled-info--wrapper"
  }, [_c('div', {
    staticClass: "crawled-info--label"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('models.project_lead.crawled_infos.domain')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "crawled-info--value"
  }, [_c('a', {
    attrs: {
      "href": 'http://' + _vm.data.domain,
      "target": "_blank"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.data.domain) + "\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'foundedYear')) ? _c('crawled-info', {
    attrs: {
      "label": "foundedYear",
      "value": _vm.data.foundedYear
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'country')) ? _c('crawled-info', {
    attrs: {
      "label": "country",
      "value": _vm.data.country
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'location')) ? _c('crawled-info', {
    attrs: {
      "label": "location",
      "value": _vm.data.location
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'description')) ? _c('crawled-info', {
    attrs: {
      "label": "description",
      "value": _vm.data.description
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'category')) ? _c('crawled-info', {
    attrs: {
      "label": "category",
      "value": _vm.category
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'tags')) ? _c('crawled-info', {
    attrs: {
      "label": "tags",
      "value": _vm.tags
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'site.emailAddresses')) ? _c('div', {
    staticClass: "crawled-info--wrapper"
  }, [_c('div', {
    staticClass: "crawled-info--label"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('models.project_lead.crawled_infos.emailAddresses')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.data.site.emailAddresses), function(item) {
    return _c('div', {
      key: item,
      staticClass: "crawled-info--value"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + item
      }
    }, [_vm._v("\n          " + _vm._s(item) + "\n        ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'site.phoneNumbers')) ? _c('div', {
    staticClass: "crawled-info--wrapper"
  }, [_c('div', {
    staticClass: "crawled-info--label"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('models.project_lead.crawled_infos.phoneNumbers')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.data.site.phoneNumbers), function(item) {
    return _c('div', {
      key: item,
      staticClass: "crawled-info--value"
    }, [_c('a', {
      attrs: {
        "href": 'tel:' + item
      }
    }, [_vm._v("\n          " + _vm._s(item) + "\n        ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'metrics')) ? _c('div', {
    staticClass: "crawled-info--wrapper"
  }, [_c('div', {
    staticClass: "crawled-info--label"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('models.project_lead.crawled_infos.metrics')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.data.metrics), function(item, key) {
    return (item) ? _c('div', {
      key: item,
      staticClass: "crawled-info--value"
    }, [_vm._v("\n        " + _vm._s(key) + ": " + _vm._s(item) + "\n      ")]) : _vm._e()
  })], 2) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bbff644","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/CrawledInfos.vue
// module id = 1951
// module chunks = 0